export class WhatsAppSignupConfig {
  constructor(
    readonly metaAppId: string,
    readonly metaConfigId: string,
    readonly solutionId: string,
  ) {}

  // The backend defaults every field to an empty string until the Meta app is configured.
  get isComplete(): boolean {
    return Boolean(this.metaAppId && this.metaConfigId && this.solutionId);
  }
}
